(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('PaperPrice', PaperPrice);

    PaperPrice.$inject = ['$resource'];

    function PaperPrice ($resource) {
        var resourceUrl =  'api/paper-prices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
